<template>
  <div
    class="task__item"
    @click="onActionClick">
    <div class="task__title">
      <div class="task__title-wrap">
        <span>Player ID: {{ objCard?.player_id || 0 }}</span>
        <b-badge
          v-if="objCard?.vip"
          variant="vip">
          VIP
        </b-badge>

        <b-badge
          v-if="objCard?.available_bonus_after_call && !objCard?.available_bonus"
          variant="bonus">
          <font-awesome-icon :icon="dataGiftIcon" />
          Bonus Avaliable
        </b-badge>

        <b-badge
          v-if="objCard?.available_bonus_after_call === false && objCard?.available_bonus === false"
          variant="no-bonus">
          <font-awesome-icon :icon="solidGiftIcon" />
          No Bonuses
        </b-badge>

        <span
          v-if="!commentNot"
          :class="objCard?.comment_count > 0 ? 'task__comment-icon is-active' : 'task__comment-icon'">
          &nbsp;{{ objCard?.comment_count || 0 }}&nbsp;
          <font-awesome-icon :icon="iconComment" />
        </span>
      </div>

      <span
        v-if="objCard?.closed_by && !unvisibleTypeClosed"
        class="card-project__closed-label"
        style="font-size: 14px; white-space: nowrap;">
        {{ objCard?.closing_type }} Closed
        <font-awesome-icon
          class="success ml-1"
          :icon="iconCheckCircle" />
      </span>
    </div>

    <call-badge-table
      v-if="objCard?.execute_before"
      type="warning">
      {{ $options.filters.dateFilter(objCard?.execute_before) || '' }}
    </call-badge-table>

    <call-badge-table
      v-if="objCard?.operator_name"
      type="success"
      :icon="iconUser">
      {{ objCard?.operator_name || '' }}
    </call-badge-table>
  </div>
</template>

<script>
import { faComment, faUser, faCheckCircle, faGift } from '@fortawesome/pro-regular-svg-icons';
import { faGift as fasGift } from '@fortawesome/pro-solid-svg-icons';
import CallBadgeTable from '../../common/CallBadgeTable';
import { BBadge } from 'bootstrap-vue';

export default {
  name: 'CallMobileTaskCard',
  components: {
    CallBadgeTable,
    BBadge
  },
  props: {
    objCard: {
      type: Object,
      default: () => ({})
    },
    commentNot: {
      type: Boolean,
      default: false
    },
    unvisibleTypeClosed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      iconComment: faComment,
      iconUser: faUser,
      iconCheckCircle: faCheckCircle,
      dataGiftIcon: faGift,
      solidGiftIcon: fasGift
    };
  },
  methods: {
    onActionClick () {
      this.$emit('on-action-click', this.objCard);
    }
  }
};
</script>
